import React, { useEffect, useState } from "react";

import { Breadcrumbs } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import ActionButtons from "../../../../../../../components/Generic/ActionButtons";
import SubHeader from "../../../../../../../components/Generic/SubHeader";
import UITabMaterial, { PanelProps } from "../../../../../../../components/Generic/UITabMaterial";
import LoadingModal from "../../../../../../../components/LoadingModal";
import { PRIVATE_ROUTES } from "../../../../../../../constants";
import {
  TransshipmentParams,
  useTransshipmentState,
} from "../../../../../../../context/TransshipmentContext";
import { useActionTransshipment } from "../../../../../../../hooks/useActionTransshipment";
import Details from "./components/Details";
import SkeletonDetails from "./components/Skeleton";
import useStyles, { ButtonContainer } from "./styles";
import { useAppState } from "Context/StateContext";
import { checkResourceCan, FN_NAMES, hasPermission, isShowAction } from "Util/permissions";
import { ResourceCanEnum, ResourceName } from "Util/enums/accessRule";

const TransshipmentTabs = () => {
  const history = useHistory();
  const { t: translate } = useTranslation();

  const { transshipmentId } = useParams<TransshipmentParams>();

  const { sendTransshipment, isLoading } = useActionTransshipment();
  const { isLoadingEditTransshipment, isDisabledToEdit, errors } = useTransshipmentState();
  const { currentUser, userPermissions } = useAppState();
  const [transshipmentPermission, setTransshipmentPermission] = useState<{
    create: boolean;
  }>({ create: false });

  useEffect(() => {
    if (userPermissions && userPermissions?.length > 0) {
      setTransshipmentPermission({
        create:
          checkResourceCan(userPermissions, ResourceName.TRANSSHIPMENT, ResourceCanEnum.EDIT) &&
          hasPermission(userPermissions, FN_NAMES.FUNCTION_WAREHOUSING_TRANSSHIPMENT_ADD_NEW),
      });
    }
  }, [userPermissions]);

  const classes = useStyles();

  const goBack = () => {
    if (history.action !== "POP") {
      history.goBack();
    } else {
      history.replace(PRIVATE_ROUTES.TRANSSHIPMENTS);
    }
  };

  const detailsPanel: PanelProps = {
    key: "details",
    className: classnames(classes.uiTab, classes.tabDetails),
    menuItem: translate("details"),
    hasError: !!errors.length,
    render: () =>
      !transshipmentId && !isShowAction(currentUser, transshipmentPermission.create) ? undefined : (
        <Details />
      ),
    loading: isLoadingEditTransshipment,
    skeleton: () => <SkeletonDetails />,
  };

  return (
    <div className={classes.container}>
      <SubHeader showWarehouseSelect title={translate("transshipment")}></SubHeader>
      <div className={classes.mainDiv}>
        <UITabMaterial leftPanels={[detailsPanel]} />
        {!isLoadingEditTransshipment && (
          <ButtonContainer>
            <ActionButtons
              textSavePublish={translate("saveAndPublish")}
              onCancel={() => goBack()}
              onSave={() => sendTransshipment(false)}
              onSavePublish={
                isLoading || isDisabledToEdit ? undefined : () => sendTransshipment(true)
              }
              loading={isLoading}
            />
          </ButtonContainer>
        )}
      </div>
      <LoadingModal showing={isLoading} />
    </div>
  );
};

export default TransshipmentTabs;
